module.exports = __webpack_public_path__ + "65b20c56edb0ae6f6523f7242256bf25.svg";